import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinranjangaonmidc() {



const cardData =
  {
    keyword: 'Bus On Rent in Ranjangaon MIDC',
    heading: 'Sanavi Travels: Bus On Rent in Ranjangaon MIDC',
    headingDescription: 'Sanavi Travels provides reliable, professionally managed, and efficient Bus On Rent in Ranjangaon MIDC, catering to industrial employees, corporate teams, factory staff, vendors, families, wedding groups, schools, and outstation travelers. Ranjangaon MIDC is one of the most important industrial corridors in Pune district, housing major manufacturing plants, warehouses, and corporate offices with round-the-clock operational shifts. Due to daily employee movement, shift-based transportation, corporate meetings, training programs, factory visits, and occasional social travel requirements, organized group transportation is essential in this region. Sanavi Travels offers a wide fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and large seating-capacity buses designed specifically for industrial and long-distance usage. Each vehicle is maintained with clean interiors, comfortable push-back seating, strong suspension for highway travel, proper ventilation, and ample luggage space for staff and equipment. Our experienced drivers are well-acquainted with Ranjangaon MIDC internal roads, factory entry points, Pune–Ahmednagar highway, Shirur routes, and nearby villages, ensuring disciplined driving, punctual pickups, and smooth operations even during shift changes. With flexible rental plans, transparent pricing, dedicated corporate coordination, and 24/7 customer support, Sanavi Travels ensures that bus rental in Ranjangaon MIDC is dependable, cost-effective, and completely stress-free for industrial and commercial travel needs.',

    top: 'Top Places to Visit Near Ranjangaon MIDC with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ranjangaon MIDC Industrial Area",
    "description": "Ranjangaon MIDC is a major industrial hub hosting multinational companies, manufacturing units, warehouses, and logistics centers. Thousands of employees travel daily for different shift timings, training programs, audits, and factory operations. Bus rental services play a critical role in ensuring safe, punctual, and organized employee transportation while reducing congestion and dependency on individual vehicles."
  },
  {
    "title": "Ranjangaon Ganpati Temple",
    "description": "The famous Ranjangaon Ganpati Temple, one of the Ashtavinayak shrines, attracts devotees from across Maharashtra. Corporate teams, factory workers, families, and pilgrimage groups often plan group visits to the temple. Hiring buses ensures a peaceful, well-coordinated, and comfortable travel experience for large devotional groups."
  },
  {
    "title": "Shirur Town",
    "description": "Shirur town acts as the primary residential and commercial center near Ranjangaon MIDC. Employees and families frequently travel between Shirur and the MIDC area for work, shopping, healthcare, and education. Bus hire services provide reliable and economical group transport on these routes."
  },
  {
    "title": "Pune–Ahmednagar Highway",
    "description": "The Pune–Ahmednagar highway connects Ranjangaon MIDC to Pune city, Ahmednagar, and surrounding industrial zones. This highway is heavily used for corporate travel, logistics movement, and long-distance employee transport, making bus rentals a safe and efficient choice."
  },
  {
    "title": "Nearby Industrial Zones",
    "description": "Ranjangaon MIDC is closely connected to other industrial clusters, making inter-factory travel common for meetings, audits, and vendor coordination. Bus rentals help companies manage group movement professionally and on time."
  },
  {
    "title": "Employee Residential Areas",
    "description": "Many employees reside in nearby villages and towns such as Shirur, Karegaon, and surrounding rural pockets. Daily commute buses help maintain discipline, reduce travel fatigue, and improve workforce efficiency."
  },
  {
    "title": "Corporate Training Centers",
    "description": "Several companies conduct regular training sessions, safety drills, and induction programs for new staff. Bus hire services support bulk employee transportation for these programs with ease."
  },
  {
    "title": "Wedding and Social Venues",
    "description": "Employees and local residents often organize weddings and social events around Ranjangaon MIDC. Hiring buses ensures smooth guest transportation without disturbing factory operations or parking limitations."
  },
  {
    "title": "Outstation Corporate Routes",
    "description": "Ranjangaon MIDC frequently serves as a starting point for outstation corporate travel to Pune, Mumbai, Nashik, and Ahmednagar. Bus rentals provide a comfortable and cost-efficient solution for group travel."
  },
  {
    "title": "Rural and Village Connectivity",
    "description": "Surrounding villages rely on Ranjangaon MIDC for employment opportunities. Bus rentals help connect rural workers to industrial workplaces safely and reliably."
  }
]
,



"services": [
{
"name": "Bus On Rent in Ranjangaon MIDC",
"description": "Bus On Rent in Ranjangaon MIDC provides professionally managed, safe, and reliable transportation for industrial employees, corporate teams, factory staff, and group travelers. This service is designed to handle daily employee shifts, corporate meetings, training programs, audits, factory visits, and social events with precision and punctuality. Our buses are equipped with clean interiors, comfortable push-back seating, strong suspension for highway stability, proper ventilation, and sufficient space for staff belongings. Experienced drivers familiar with MIDC routes, factory gates, and highway traffic ensure disciplined driving, timely pickups, and smooth operations. This service significantly reduces logistical challenges for companies while ensuring employee safety and comfort."
},
{
"name": "Bus Hire Ranjangaon MIDC",
"description": "Bus Hire Ranjangaon MIDC offers flexible and scalable transportation solutions for industries, contractors, and organizations. Whether it is daily employee movement, special project travel, or one-time corporate events, this service ensures organized, cost-effective, and dependable group transport with minimal operational disruption."
},
{
"name": "AC Bus Rental Ranjangaon MIDC",
"description": "AC Bus Rental Ranjangaon MIDC is ideal for long-distance corporate travel and summer shifts, providing air-conditioned comfort that reduces fatigue and improves employee travel experience during extended journeys."
},
{
"name": "Non AC Bus on Rent Ranjangaon",
"description": "Non AC Bus on Rent Ranjangaon offers economical transportation for short routes, nearby villages, and daily workforce movement while maintaining safety and cleanliness standards."
},
{
"name": "Luxury Bus on Rent Ranjangaon MIDC",
"description": "Luxury Bus on Rent Ranjangaon MIDC provides premium travel solutions for senior executives, corporate guests, auditors, and VIP visits, featuring superior interiors and enhanced comfort."
},
{
"name": "Mini Bus Hire Ranjangaon",
"description": "Mini Bus Hire Ranjangaon is suitable for smaller teams, departmental travel, training batches, and vendor visits, offering flexibility and easy maneuverability within MIDC areas."
},
{
"name": "32 Seater Bus on Rent Ranjangaon",
"description": "32 Seater Bus on Rent Ranjangaon is ideal for medium-sized employee groups, balancing seating capacity with comfort for daily shifts and short outstation trips."
},
{
"name": "35 Seater Bus Hire Ranjangaon MIDC",
"description": "35 Seater Bus Hire Ranjangaon MIDC supports large workforce transportation, factory events, and group travel requirements efficiently."
},
{
"name": "Bus on Rent Ranjangaon for Wedding",
"description": "Bus on Rent Ranjangaon for Wedding ensures smooth and coordinated transportation for guests, helping employees and families manage large gatherings without travel stress."
},
{
"name": "Bus on Rent Ranjangaon for Corporate",
"description": "Bus on Rent Ranjangaon for Corporate provides structured and professional transport for meetings, conferences, plant visits, and employee engagement programs."
},
{
"name": "Bus on Rent Ranjangaon for Picnic",
"description": "Bus on Rent Ranjangaon for Picnic offers safe and enjoyable group travel for factory outings, team-building activities, and family leisure trips."
},
{
"name": "Bus Rental Ranjangaon MIDC Outstation",
"description": "Bus Rental Ranjangaon MIDC Outstation provides dependable long-distance transportation to Pune, Mumbai, Nashik, Ahmednagar, and other business destinations."
},
{
"name": "Bus Hire Ranjangaon with Driver",
"description": "Bus Hire Ranjangaon with Driver offers chauffeur-driven buses with trained drivers who manage traffic, schedules, and route planning professionally."
},
{
"name": "Affordable Bus Rental Ranjangaon MIDC",
"description": "Affordable Bus Rental Ranjangaon MIDC delivers cost-effective transportation solutions without compromising on safety, punctuality, or vehicle quality."
},
{
"name": "Best Bus Service Ranjangaon",
"description": "Best Bus Service Ranjangaon is trusted by industries and organizations for its punctual operations, clean buses, transparent pricing, and reliable service by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Ranjangaon MIDC", "Bus Hire Ranjangaon MIDC"],
["AC Bus Rental Ranjangaon", "Non AC Bus Hire Ranjangaon"],
["Luxury Bus Ranjangaon", "Mini Bus Hire Ranjangaon"],
["32 Seater Bus Ranjangaon", "35 Seater Bus Ranjangaon"],
["Corporate Bus Ranjangaon", "Wedding Bus Ranjangaon"],
["Picnic Bus Ranjangaon", "Outstation Bus Ranjangaon"],
["Bus Hire Ranjangaon with Driver", "Affordable Bus Rental Ranjangaon"],
["Best Bus Service Ranjangaon", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Ranjangaon MIDC with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels specializes in industrial and corporate bus transportation in Ranjangaon MIDC."
  },
  {
    "WhyChooseheading": "Industrial Route Expertise",
    "WhyChoosedescription": "Drivers are trained and familiar with MIDC layouts, factory gates, and shift timings."
  },
  {
    "WhyChooseheading": "Clean and Reliable Fleet",
    "WhyChoosedescription": "All buses are maintained to meet corporate and safety standards."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing structure with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Support",
    "WhyChoosedescription": "Dedicated assistance for corporate coordination and emergencies."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Daily, monthly, and customized contracts available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Regular sanitization ensures employee safety."
  },
  {
    "WhyChooseheading": "On-Time and Disciplined Service",
    "WhyChoosedescription": "Strict adherence to schedules and punctual operations."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services in Ranjangaon MIDC?',
    answer: 'Yes, Sanavi Travels offers dedicated bus rental services in Ranjangaon MIDC for industries and groups.'
  },
  {
    question: 'Are buses available for employee shift transportation?',
    answer: 'Yes, we provide daily and contractual employee transportation services.'
  },
  {
    question: 'Can I hire a bus for corporate outings and picnics?',
    answer: 'Yes, buses are available for corporate outings, picnics, and team events.'
  },
  {
    question: 'Are drivers trained for industrial routes?',
    answer: 'Yes, our drivers are experienced with MIDC and highway routes.'
  },
  {
    question: 'Is outstation bus rental available from Ranjangaon MIDC?',
    answer: 'Yes, outstation travel services are available.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'Sanavi Travels manages our employee transport in Ranjangaon MIDC very professionally.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Pooja Deshmukh',
    feedback: 'We booked a corporate bus from Ranjangaon MIDC for an outing. Excellent service and clean buses.',
    rating: 5
  }
];




















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Ranjangaon MIDC - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Ranjangaon MIDC for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Ranjangaon MIDC | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Ranjangaon MIDC with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/235.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinranjangaonmidc;